export const quantumPageUK = {
  "seo": {
    "title": "Суверенні LLM та Квантовий ШІ | pAIoneer Labs GmbH",
    "description": "Наша мета з Німеччини: під керуванням Veridion («ШІ розвиває ШІ далі») створити власні компактні мовні моделі та квантові трансформери, які конкуруватимуть із великими моделями США та Китаю."
  },
  "hero": {
    "kicker": "Made in Germany · ШІ розвиває ШІ",
    "title": "Суверенні LLM та Квантовий ШІ",
    "claim": "Наша мета з Німеччини: розробити власні мовні моделі та квантові трансформери, які в майбутньому складуть конкуренцію великим моделям зі США та Китаю.",
    "subtitle": "У реальних корпоративних проєктах наявні європейські підходи — німецькі моделі від Aleph Alpha (як-от Kolibri), французькі моделі навколо Mistral, EuroLLM та особливо швейцарська модель Apertus — були протестовані на практичних задачах бізнесу. Жодна з них не задовольняє вимоги підприємств. Тому наш ШІ під керуванням [Veridion](veridion) («ШІ розвиває ШІ далі») робить наступний крок: досліджує й проєктує шлях до компактних мовних моделей Made in Germany, які будуть значно сильнішими за французькі моделі, і як другий напрям розвиває власні квантові трансформери.",
    "cta": "Домовитися про розмову"
  },
  "pillars": {
    "title": "Над чим працює наш ШІ",
    "subtitle": "Два дослідницькі напрями, у яких наші цифрові співробітники проєктують нові архітектури, перевіряють їх у симуляторі та крок за кроком будують.",
    "items": [
      {
        "title": "Що мовна модель має виконувати на практиці",
        "description": "У реальній роботі вирішальними є багатоступеневе логічне мислення, надійна робота з інструментами у довгих ланцюжках, якісна розробка коду та безпомилкові офісні процеси. За цим ми оцінюємо кожну архітектуру з першого дня."
      },
      {
        "title": "Компактні моделі для власної інфраструктури",
        "description": "Замість дедалі більших дата-центрів нашою метою буде зосередити глибоку здатність до міркувань у компактній моделі, яку компанії зможуть запускати локально на власному обладнанні."
      },
      {
        "title": "Квантові трансформери та Квантовий ШІ",
        "description": "У другому напрямі ми досліджуємо поєднання трансформерних архітектур із параметризованими квантовими схемами та тензорними мережами для відкриття нових класів моделей."
      },
      {
        "title": "Власна Quantum IDE та квантові процесори",
        "description": "У нашій власній Quantum IDE ШІ-співробітники конструюють, симулюють і тестують нові квантові схеми проти класичних еталонів перед запуском на реальному квантовому залізі."
      }
    ]
  },
  "gate": {
    "title": "Від наукового аналізу до креслення",
    "subtitle": "Кожен крок розробки спирається на перевірену літературу, корпоративну пам'ять і вимірювані порівняння.",
    "stages": [
      {
        "step": "Крок 01",
        "title": "Аналіз літератури та корпоративна пам'ять",
        "description": "Наші ШІ-співробітники безперервно опрацьовують найновіші наукові статті з мовних і квантових архітектур та зберігають перевірені факти у графі знань компанії."
      },
      {
        "step": "Крок 02",
        "title": "План навчання та симуляція схем",
        "description": "Разом із продуктовою командою формується детальний план тренування нашої майбутньої мовної моделі, а паралельно у Quantum IDE випробовуються нові квантові схеми."
      },
      {
        "step": "Крок 03",
        "title": "Наукова перевірка у процесі IDD",
        "description": "Фізики та дослідники ШІ перевіряють кожну гіпотезу, вимірювання й проєкт через [Intent-Driven Development](idd) (IDD) як human-in-the-loop і затверджують наступний крок."
      }
    ]
  },
  "stack": {
    "title": "Людина і ШІ в єдиному дослідницькому підрозділі",
    "subtitle": "Дослідження, продуктова інженерія та науковий нагляд працюють узгоджено у фіксованих циклах.",
    "items": [
      {
        "title": "Цифрові дослідники цілодобово",
        "description": "Спеціалізовані ШІ-співробітники ведуть пошук літератури, математичні викладки, проєктування схем та оцінювання результатів 24/7."
      },
      {
        "title": "Фізики в контурі Human-in-the-Loop",
        "description": "Науковці задають напрям досліджень, критично перевіряють припущення й ухвалюють рішення щодо запусків на залізі та публікацій."
      },
      {
        "title": "Зв'язок із розробкою продуктів",
        "description": "У тісній взаємодії з продуктовою командою підтверджені результати досліджень переходять безпосередньо у наші інструменти та майбутні корпоративні рішення."
      },
      {
        "title": "Простежуваність до першоджерела",
        "description": "Кожне архітектурне рішення, відхилений варіант і результат вимірювань залишаються задокументованими та доступними для перевірки."
      }
    ]
  },
  "cta": {
    "title": "Обговорення досліджень",
    "subtitle": "Бажаєте обговорити наші дослідження суверенних мовних моделей і квантових трансформерів? Напишіть нам.",
    "button": "Написати повідомлення"
  }
};
